export default __webpack_public_path__ + "static/media/mic.919c4583.svg";